{
  "Yapılacaklar": "Takenlijst",
  "yapilacaklar": {
    "Oluşturma Tarih": "Aanmaakdatum",
    "Yapılacaklar": "Takenlijst",
    "yapilacaklar": "yapilacaklar",
    "talep_takip": "talep_takip",
    "Talep Edilen": "Talep Edilen",
    "Talep Durumu": "Talep Durumu",
    "Talep Notu": "Talep Notu",
    "Sonuç Tarih": "Sonuç Tarih",
    "Sonuç": "Resultaat",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Durum": "Status",
    "Konu": "Onderwerp",
    "Yenile": "Vernieuwen",
    "Yeni": "Nieuw",
    "Güncelle": "Bijwerken",
    "Kaydet": "Opslaan",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Not": "Notitie"
  }
}
